import {Component} from 'react';
import PropTypes from 'prop-types';
import {Label} from 'semantic-ui-react';
import NavigationIcon from './NavigationIcon';
import ImageLoader from 'components/ImageLoader/ImageLoader';
import Spinner from 'components/Spinner';

export default class ImageGallery extends Component {

    static propTypes = {
        currentIndex: PropTypes.number,
        images: PropTypes.array.isRequired,
        onIndexChange: PropTypes.func,
    };

    static defaultProps = {
        images: [],
    };

    constructor(props) {
        super(props);
        this.state = {
        	showImage: false,
            currentIndex: props.currentIndex || 0,
            currentImage: null,
        };
    }

    
    componentDidMount() {
      this.loadImage();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.state.currentIndex !== prevState.currentIndex) {
        this.loadImage();
      }
    }

    loadImage = () => {
      const {images} = this.props;
      const {currentIndex} = this.state;
      const image = new Image(400, 500);
      const compo = this;
      image.onload = () => {
        compo.setState({showImage: true, hasError: false});
      };
      image.src = images[currentIndex];
      image.onerror = (e) => {
        e.target.onerror = null;
        compo.setState({showImage: true, hasError: true});
      };
    };
  
    updateState({currentIndex, showImage}) {
        this.setState({currentIndex, showImage});
        if (this.props.onIndexChange) {
            this.props.onIndexChange(currentIndex);
        }
    }

    next = () => {
        const {images} = this.props;
        const next = this.state.currentIndex + 1;
        this.updateState({
            currentIndex: next >= images.length ? 0 : next,
            showImage: false,
        });
    };

    previous = () => {
        const {images} = this.props;
        const next = this.state.currentIndex - 1;
        this.updateState({
            currentIndex: next < 0 ? images.length - 1 : next,
            showImage: false,
        });
    };

    render() {
        const {images} = this.props;
        const {currentIndex, showImage} = this.state;

        // disclaimer
	    // - uses a hidden image to size the div.
	    // - the image is backgrounded to prevent it being selected on double click.
        return (
            <div className="image-gallery"
                 style={{
                     backgroundSize: 'cover',
                     display: 'block',
                     minHeight: '520px',
                 }}>
                <Label className="index" color="black" style={{
                    zIndex: 1,
                    position: 'absolute',
                    padding: '1em',
                    borderTopLeftRadius: '0'
                }}>
                    {currentIndex + 1} of {images.length}
                </Label>
                <NavigationIcon displayed={images.length > 1}
                                name="chevron left"
                                size="huge"
                                className="previous"
                                style={{left: '8%', paddingRight: '0.1em'}}
                                data-testid="img-gallery-left-arrow"
                                onClick={this.previous}/>
				{showImage &&
                <ImageLoader
                    fluid
                    className="current-image ui image fluid"
                    src={images[currentIndex]}
                    alt="image gallery image"
                    style={{
                      display: 'inline-block',
                      maxWidth: '100%',
                      height: 'auto',
                      objectFit: 'contain'
                  }}
                />
                }
        		{!showImage && <Spinner/>}
                <NavigationIcon displayed={images.length > 1}
                                name="chevron right"
                                size="huge"
                                className="next"
                                style={{right: '8%', paddingLeft: '0.1em'}}
                                data-testid="img-gallery-right-arrow"
                                onClick={this.next}/>
            </div>
        );
    }
};

